import { createNbaToken, getNbaUserInfo, storeNbaTokens } from "./api";
import { fetchUserData, getDeviceId, getToken, setToken } from "../../../helpers";
import logger from "../../../logger";
import axios from "axios";


const checkNbaAuth = () => {
    if (typeof window === "undefined") return;

    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    const nbaCode = urlParams.get("code"); 
    const nbaState = urlParams.get("state");
    const nbaError = urlParams.get("error");
    const getClientStateKey = localStorage.getItem("nbaAuthStateKey")

    // NBA reports a failed login by sending the user back with an error instead of a code
    if(nbaError){
        logger(`NBA login not completed: ${nbaError} - ${urlParams.get("error_description")}`, "error")
        return;
    }

    // No OAuth callback params — nothing to do.
    if (!nbaCode) return;

    // Require a non-empty client-stored state AND a matching URL state.
    // Without this, null == null when neither side set state, which would
    // accept an unsolicited ?code=... (login / account-linking CSRF).
    if (!getClientStateKey || !nbaState || getClientStateKey !== nbaState) {
        logger("NBA login rejected: missing or mismatched OAuth state", "error")
        return;
    }

    return createNbaToken(nbaCode).then((res) => {
        storeNbaTokens(res.data)
        // getNbaUserInfo().catch((err) => logger(`NBA user info failed: ${err}`, "error"))
        return nbaTokenExchangeVL(res?.data?.access_token, res?.data?.refresh_token)
    }).then((vlTokenRes) => {
        const vlUser = vlTokenRes?.data
        setToken({
            authorizationToken: vlUser?.authorizationToken,
            refreshToken: vlUser?.refreshToken
        })
        localStorage.removeItem("nbaAuthStateKey")
        return fetchUserData(vlUser?.userId, vlUser?.authorizationToken)
    }).then(() => {
        //reload on a clean url so the app renders with the logged in user
        window.location.href = window.location.origin
    }).catch((err) => {
        logger(`NBA login failed: ${err}`, "error")
    })
}

const nbaTokenExchangeVL = async(nbaAccessToken, nbaRefreshToken) => {
    var url = `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/v4/identity/nba/viewlift/token`
    var deviceId = getDeviceId();
    const token = await getToken();
    return axios({
        method: "POST",
        url: url,
        params: {
          platform: "web_browser",
          deviceName: "web_browser",
          deviceId: deviceId
        },
        headers: {
            "Authorization": token, 
            "x-api-key": window?.xApiKey,
            "Content-Type": "application/json"
        },
        data: {
            site: window?.app_data?.site?.siteInternalName || null, 
            nbaAccessToken: nbaAccessToken,
            nbaRefreshToken: nbaRefreshToken
        }
      })
}

export {checkNbaAuth}
